import { render, staticRenderFns } from "./newsPreviewPage.vue?vue&type=template&id=38377068&"
import script from "./newsPreviewPage.vue?vue&type=script&lang=ts&"
export * from "./newsPreviewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports